import React from 'react'
import { Eval } from '@app/evaluation-core/types'
import { CourseOptionView } from '@app/evaluation-settings-menu/HeaderArea.styles'
import FeatherIcon from '@ovaeasy/react-native-vector-icons/Feather'
import { DropDownMenu } from '@app/ui/dropdown-menu/DropDownMenu'
import * as S from './styled'
import { useSnackbar } from '@app/snackbar'
import EvalStatusIndicator from '../CoursesList/EvalStatusIndicator'

interface InfoDropdownProps {
  evaluation: Eval
  xAdj?: number
  yAdj?: number
  relative?: boolean
}

const InfoDropdown = ({
  evaluation,
  xAdj,
  yAdj,
  relative,
}: InfoDropdownProps) => {
  const [openSnackbar] = useSnackbar()

  const copyToClipboard = async () => {
    if (evaluation.id) {
      await navigator.clipboard.writeText(evaluation.id)
      openSnackbar('Rating ID copied to clipboard.')
    }
  }

  return (
    <DropDownMenu
      width={300}
      renderValue={() => (
        <S.DropdownTitleContainer>
          <S.DropdownTitleClub>{evaluation.clubName}</S.DropdownTitleClub>
          <S.DropdownTitleCourse>
            {evaluation.courseName || 'Course'}
          </S.DropdownTitleCourse>
        </S.DropdownTitleContainer>
      )}
      xAdj={xAdj}
      yAdj={yAdj}
      relative={relative}
    >
      <CourseOptionView>
        <S.OuterContainer>
          <S.Header>
            <S.ClubName>{evaluation.clubName}</S.ClubName>
            <S.CourseName>{evaluation.courseName}</S.CourseName>
            <EvalStatusIndicator status={evaluation?.status} />
          </S.Header>

          <S.Divider />

          <S.Section>
            <S.Row>
              <S.Label>Rating Name</S.Label>
              <S.Value>{evaluation?.saveName || '-'}</S.Value>
            </S.Row>
            {evaluation.evaluationDate && (
              <S.Row>
                <S.Label>Rating Date</S.Label>
                <S.Value>
                  {new Date(evaluation.evaluationDate).toLocaleDateString(
                    'sv-SE'
                  )}
                </S.Value>
              </S.Row>
            )}
            <S.Row>
              <S.Label>Manual Version</S.Label>
              <S.Value>
                {evaluation.manualVersion?.replace(/_/g, '.') || 'N/A'}
              </S.Value>
            </S.Row>
          </S.Section>

          <S.Divider />

          <S.Section>
            <S.Row>
              <S.Label>Rating ID</S.Label>
              <S.CopyButton onClick={copyToClipboard}>
                <FeatherIcon name="clipboard" size={14} />
                <S.Value>{evaluation.id}</S.Value>
              </S.CopyButton>
            </S.Row>
            {evaluation.branchId && (
              <S.Row>
                <S.Label>Branch ID</S.Label>
                <S.Value>{evaluation.branchId}</S.Value>
              </S.Row>
            )}
          </S.Section>
        </S.OuterContainer>
      </CourseOptionView>
    </DropDownMenu>
  )
}

export default InfoDropdown
